import workloadCore from '../../workload/core';
import workloadRendererGrid from '../../workload/core/render/grid';

export default instance => {
  instance.attachEvent('onClickGridExpandButton', () => {
    instance.render();
    workloadRendererGrid.toggleGrid();
    workloadCore.calculateAndRender();
  });
};
